var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.dataList),function(row,index){return (row.type!=3)?_c('media',{attrs:{"options":row}}):_vm._e()}),_c('page',{staticClass:"pagination",attrs:{"total":_vm.tablePage.total,"page":_vm.tablePage.currentPage},on:{"currentPage":_vm.currentPage}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }